import { CircleCheck24, Chat24, Date24, Edit24 } from '@bphxd/ds-core-react/lib/icons';
import { formatDate } from 'date-fns';
import { extractAndFormatName } from '../../organisms/AspectsTable/util';
import classes from './JointSigningStep.module.scss';
import clsx from 'clsx';

interface StepCardProps {
  step: number;
  title: string;
  date: Date;
  signedBy: string;
  comments: string;
}

export const StepCard: React.FC<StepCardProps> = ({ step, title, date, signedBy, comments }) => {
  return (
    <div className={clsx({ [classes.card]: true, [classes.active]: !!signedBy })}>
      <div className={classes.cardHeader}>
        <div className={classes.step}>{`Step ${step}`}</div>
        <div>
          {signedBy ? (
            <>
              <div className={classes.signedBy}>{extractAndFormatName(signedBy)}</div>
              <CircleCheck24
                className={classes.checkIcon}
                title={`Signed by ${extractAndFormatName(signedBy)}`}
              />
            </>
          ) : (
            <Edit24 className={classes.alertIcon} title="Click to Sign"/>
          )}
        </div>
      </div>
      <div className={classes.cardBody}>{title}</div>
      {signedBy && (
        <div className={classes.cardFooter}>
          <div>
            <Date24 />
            <span className={classes.date}>{formatDate(date, 'dd-MMM-yyyy')}</span>
          </div>
          {comments && <Chat24 />}
        </div>
      )}
    </div>
  );
};
